import { IDepedency, VersionDetails } from './../interfaces/common/dependencies.interface';

export default class Dependency implements IDepedency {    
    project: string = ""
    appSettingsKey: string = ""
    environments: string[] = []
    versions?: VersionDetails[] = []
        
    constructor(project: string, environments: string[], appSettingsKey: string, versions?: VersionDetails[]){
        this.project = project
        this.environments = environments
        this.versions = versions
        this.appSettingsKey = appSettingsKey
    }

  
    
}